var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Lista de notícias")]),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","size":"6","color":"yellow darken-2"}}):_vm._e(),_c('news-list',{attrs:{"news":_vm.news}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }